import { Wordmark } from "./Wordmark";

interface Props {
  banner: string;
  scenarioName?: string;
  sessionFingerprint?: string;
  /** When provided, banner shows action buttons that open the entry modal. */
  onMenu?: (tab: "host" | "join" | "im") => void;
}

export function Banner({ scenarioName, sessionFingerprint, onMenu }: Props) {
  return (
    <header className="banner">
      <div style={{ display: "flex", alignItems: "center", gap: 18 }}>
        <Wordmark variant="lockup" height={28} />
        <span className="meta" aria-hidden style={{ color: "var(--color-divider-strong)" }}>
          /
        </span>
        <span className="meta">Incident Response Live-Fire</span>
        {scenarioName && (
          <>
            <span className="meta" aria-hidden style={{ color: "var(--color-divider-strong)" }}>
              /
            </span>
            <span className="meta" style={{ color: "var(--color-accent)" }}>
              {scenarioName}
            </span>
          </>
        )}
      </div>
      <nav className="banner-menu" aria-label="Primary">
        {onMenu && (
          <>
            <button onClick={() => onMenu("host")}>Host</button>
            <button onClick={() => onMenu("join")}>Join</button>
            <button onClick={() => onMenu("im")}>IM</button>
          </>
        )}
        <span className="training-tag">Training</span>
        {sessionFingerprint && <span className="meta">id {sessionFingerprint}</span>}
      </nav>
    </header>
  );
}
